import { Route, Routes, HashRouter as Router } from 'react-router-dom'

import Admin from '.'
import Analytics from './packs/Analytics'
import ArtworkBuilder from './packs/ArtworkBuilder'
import Dashboard from './packs/Dashboard'
import LayoutTemplates from './packs/LayoutTemplates'
import Projects from './packs/Projects'
import QualityControl from './packs/QualityControl'
import Tasks from './packs/Tasks'
import TemplatePagePartials from './packs/TemplatePagePartials'
import TemplatePages from './packs/TemplatePages'

const AdminRoutes = () => (
  <Router>
    <Admin>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/artworks/*" element={<ArtworkBuilder />} />
        <Route path="/LayoutTemplates/*" element={<LayoutTemplates />} />
        <Route path="/projects/*" element={<Projects />} />
        <Route path="/qualityControl/*" element={<QualityControl />} />
        <Route path="/tasks/*" element={<Tasks />} />
        <Route path="/templatePages/*" element={<TemplatePages />} />
        <Route path="/templatePagePartials/*" element={<TemplatePagePartials />} />
      </Routes>
    </Admin>
  </Router>
)

export default AdminRoutes
